import { Subscription } from "./subscription";
import { UserSubscriptionAddOn } from "./user-subscription-addon";

export class CurrentUser {

	firstName: string;
	lastName: string;
	name: string;
	email: string;
	profileImage: string;
	has_open_payments: boolean;
	payment_uri: string | null;
	subscription: Subscription;
	subscription_addons: UserSubscriptionAddOn[];

	get hasConnectAddon(): boolean {

		if (!this.subscription_addons) return false;

		return this.subscription_addons.some(a => a.id.toLowerCase() == 'kwo-connect-eur-monthly');
	}
}